(function () {
    "use strict";

    $(document).ready(function () {

        const nav = document.getElementById('navigation');
        const navItems = nav.querySelectorAll(".nav-item");
        const content = document.getElementById('content');
        const contentItems = content.querySelectorAll(".content-item");
        const buttons = document.querySelectorAll("button")

        const eligibilityDone = !Array
            .from(buttons, (elt) => elt.innerText)
            .some((text) => text === "Tester votre éligibilité")

        // fonction de gestion des ancres dans l'url
        function readHash() {
            const hash = window.location.hash;
            const hashString = hash.startsWith("#") ? hash.substring(1) : hash;
            const element = document.getElementById(hashString);

            // si ancre n'existe pas ou onglet pas présent
            if (element == null || hashString == "") {
                showSelectedContent('', '');
                navItems[0].classList.add("active");
                contentItems[0].classList.remove("d-none");
                cleanInvalidHash();
            }
            // sinon affichage de l'onglet correspondant à l'ancre
            else {
                if (hashString == "5ghome") {
                    showSelectedContent('nav-item-tab1', hashString);
                    if (eligibilityDone) {
                        tms_datalayer_5g_resultat_eligibilite()
                    } else {
                        tms_datalayer_5g_home_hp();
                    }
                } else if (hashString == "4ghome") {
                    showSelectedContent('nav-item-tab2', hashString);
                    if (eligibilityDone) {
                        tms_datalayer_4g_resultat_eligibilite()
                    } else {
                        tms_datalayer_4g_home_hp();
                    }
                } else if (hashString == "satellite") {
                    showSelectedContent('nav-item-tab3', hashString);
                    if (eligibilityDone) {
                        tms_datalayer_sat_resultat_eligibilite()
                    } else {
                        tms_datalayer_sat_home_hp();
                    }
                } else {
                    cleanInvalidHash();
                }
            }
        }

        function continue4gHomeOrder() {
            const mainNode = $('#internet-4ghome');
            const isGovernmentSupportEligible = mainNode.data('isGovernmentSupportEligible');
            const continueEdpUrl = mainNode.data('continueEdpUrl');

            if (isGovernmentSupportEligible === false) {
                window.location = continueEdpUrl;
            } else create4gHomeOrder()
        }

        function create4gHomeOrder() {
            const internetOtherOffersContent = document.querySelector("#other-offers-content");
            const confirmationButtonTimer = internetOtherOffersContent.dataset.confirmationButtonTimer;
            animProgress(confirmationButtonTimer);

            const mainNode = $('#internet-4ghome');
            const successUrl = mainNode.data('successUrl');
            const ctcUrl = mainNode.data('ctcUrl');
            const initCartUrl = mainNode.data('initCartUrl');
            const data = {
                offerIdSeo: mainNode.data('offerId'),
                deviceIdSeo: mainNode.data('deviceId')
            };

            $.ajax({
                method: "POST",
                url: initCartUrl,
                contentType: "application/json",
                data: JSON.stringify(data)
            }).done((response) => {
                const url = response.tunnelUrl;
                window.location.replace(url);
            }).fail((xhr) => {
                if (xhr.status === 403) {
                    // Pour les erreurs d'authentifications, on reload simplement la page
                    // appelant la xhr. MyShop va reprendre la main et gérer la perte de session.
                    location.reload();
                } else {
                    window.location.replace(ctcUrl);
                }
            });
        }

        function animProgress(confirmationButtonTimer) {
            let buttonsWithProgressBar = document.querySelectorAll(".submit-4ghome");
            buttonsWithProgressBar.forEach(buttonWithProgressBar =>  {
                    buttonWithProgressBar.setAttribute("disabled", "true");
                    buttonWithProgressBar.setAttribute("data-ob1-component", "ProgressBarDetermined");
                    buttonWithProgressBar.setAttribute("data-timer", confirmationButtonTimer);
                    Ob1Component.load(document.body);
                }
            );
        }

        // fonction nettoyage de l'ancre dans l'url
        function cleanInvalidHash() {
            const loc = window.location;
            window.history.replaceState("", "", loc.origin + loc.pathname + loc.search);
        }

        // fonction d'affichage des onglets et leur contenu
        function showSelectedContent(navselectedItem, contentSelectedItem) {
            navItems.forEach(function (navItem) {
                    navItem.classList.remove("active");
                    if (navItem.id == navselectedItem) {
                        navItem.classList.add("active");
                    }
                }
            );
            contentItems.forEach(function (contentItem) {
                    contentItem.classList.add("d-none");
                    if (contentItem.id == contentSelectedItem+'_content') {
                        contentItem.classList.remove("d-none");
                    }
                }
            );
        }

        // fonctions TMS
        function tms_datalayer_5g_home_hp() {
            Tms.view({
                id_tracking: "VosvzcHu",
                page: "home_hp_autres_offres_home_5g_rpio",
                titre_page: "5g_home_hp",
                type_page: "home_hp_autres_offres",
                sous_univers: "home_5g"
            });
        }
        function tms_datalayer_5g_resultat_eligibilite() {
            Tms.view({
                id_tracking: "TkwPvLRf",
                page: "resultat_eligibilite_autres_offres_5g_rpio",
                titre_page: "5ghome_resultat_eligibilite_eligible",
                type_page: "resultat_eligibilite_autres_offres",
                sous_univers: "home_5g",
            });
        }

        function tms_datalayer_4g_home_hp() {
            Tms.view({
                id_tracking: "fwWHk4tP",
                page: "home_hp_autres_offres_home_4g_rpio",
                titre_page: "4g_home_hp",
                type_page: "home_hp_autres_offres",
                sous_univers: "home_4g"
            });
        }

        function tms_datalayer_4g_resultat_eligibilite() {
            const mainNode = $('#internet-4ghome');
            const isSubsidized = mainNode.data('isSubsidized');
            const isEligibleFor4gHome = mainNode.data('isEligible');
            let titre_page = "";
            if (isEligibleFor4gHome) {
                titre_page = isSubsidized ? "4ghome_resultat_eligibilite_eligible_ok_subvention_ok" :
                    "4ghome_resultat_eligibilite_eligible_ok_subvention_ko";
            } else {
                titre_page = "4ghome_resultat_eligibilite_eligible_ko";
            }
            Tms.view({
                id_tracking: "qV6aydBl",
                page: "resultat_eligibilite_autres_offres_4g_rpio",
                titre_page: titre_page,
                type_page: "resultat_eligibilite_autres_offres",
                sous_univers: "home_4g"
            });
        }

        function tms_datalayer_sat_home_hp() {
            Tms.view({
                id_tracking: "sK5VHscG",
                page: "home_hp_autres_offres_home_satellite_rpio",
                titre_page: "satellite_home_hp",
                type_page: "home_hp_autres_offres",
                sous_univers: "home_satellite"
            });
        }
        function tms_datalayer_sat_resultat_eligibilite() {
            Tms.view({
                id_tracking: "f8DoXdVY",
                page: "resultat_eligibilite_autres_offres_satellite_rpio",
                titre_page: "satellite_resultat_eligibilite_eligible",
                type_page: "resultat_eligibilite_autres_offres",
                sous_univers: "home_satellite"
            });
        }

        function tms_click_onglet_5Ghome() {
            Tms.link({
                category: "onglets_haut_page",
                action: "5g_home",
                label: "page_5g_home"
            });
        }
        function tms_click_onglet_4Ghome() {
            Tms.link({
                category: "onglets_haut_page",
                action: "4g_home",
                label: "page_4g_home"
            });
        }

        function tms_click_onglet_sat() {
            Tms.link({
                category: "onglets_haut_page",
                action: "satellite",
                label: "page_satellite_home"
            });
        }

        function setUrlHash(hash) {
            const url = window.location.href.split('#')[0] + '#' + hash;
            history.pushState({}, '', url);
        }

        // écouteur des clics sur les onglets
        $('.nav-tab1').on('click', function (e) {
            e.preventDefault();
            showSelectedContent('nav-item-tab1', '5ghome');
            setUrlHash('5ghome');
            if (eligibilityDone) {
                tms_datalayer_5g_resultat_eligibilite()
            } else {
                tms_datalayer_5g_home_hp();
            }
            tms_click_onglet_5Ghome();
        });
        $('.nav-tab2').on('click', function (e) {
            e.preventDefault();
            showSelectedContent('nav-item-tab2', '4ghome');
            setUrlHash('4ghome');
            if (eligibilityDone) {
                tms_datalayer_4g_resultat_eligibilite()
            } else {
                tms_datalayer_4g_home_hp();
            }
            tms_click_onglet_4Ghome();
        });
        $('.nav-tab3').on('click', function (e) {
            e.preventDefault();
            showSelectedContent('nav-item-tab3', 'satellite');
            setUrlHash('satellite');
            if (eligibilityDone) {
                tms_datalayer_sat_resultat_eligibilite()
            } else {
                tms_datalayer_sat_home_hp();
            }
            tms_click_onglet_sat();
        });

        $('.submit-4ghome').on('click', function () {
            continue4gHomeOrder();
        });

        // écouteur si changement de l'ancre dans l'url du navigateur
        $(window).on('hashchange', function (e) {
            readHash();
        });

        // lecture des ancres dans l'url du navigateur au chargement
        readHash();

    });

}());
